// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"f97c665e","79":"693940c5","160":"4b2d0f56","328":"ed89aa17","374":"a9964354","432":"067bc46c","623":"eb639b54","705":"f03997af","858":"484132d1","862":"d3365524","956":"11800585"}[chunkId] + ".chunk.js";
};